/**
 * Sidebar Validated filter: binds RmaListFiltersStore restock-validated draft to
 * RmaListFilterControl via filterControlDataProps (single-select radio list).
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { RESTOCK_VALIDATED_TYPE } from "../../../../../services/api/rma-list-service";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import { RMA_LIST_FILTER_CONTROL_DATA_TYPE } from "../rma-list-filter-control/rma-list-filter-control-portal/rma-list-filter-control-content/rma-list-filter-control-content";
import RmaListFilterControl from "../rma-list-filter-control/rma-list-filter-control";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled?: boolean;
}

const RmaListFilterValidated: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const selectedId = rmaListFiltersStore.selectedRestockValidatedId;

    return (
        <RmaListFilterControl
            label={getTranslation("VALIDATED", scope)}
            selectedLabel={rmaListFiltersStore.selectedRestockValidatedLabel}
            disabled={disabled}
            onOpen={() => rmsMixpanelStore.trackEvent("d&_filter_validated")}
            onClear={() => rmaListFiltersStore.setRestockValidatedType(RESTOCK_VALIDATED_TYPE.ALL)}
            filterControlDataProps={{
                type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.OPTIONS,
                value: selectedId,
                options: rmaListFiltersStore.restockValidatedFilterOptions,
                onChange: (id) => {
                    rmaListFiltersStore.setRestockValidatedType(id as RESTOCK_VALIDATED_TYPE);
                },
            }}
        />
    );
});

export default RmaListFilterValidated;
